import { WHAT_HAPPENS_NEXT } from '@/data/contact';
import { Reveal } from '../Reveal';

export const WhatHappensNext = () => (
  <section aria-labelledby="what-next-heading" data-testid="what-happens-next" className="bg-mist py-16 sm:py-24">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="max-w-2xl">
        <p className="flex items-center gap-3">
          <span className="font-mono text-xs font-medium tracking-widest text-gold-700">05</span>
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-gold-700">Reassurance</span>
        </p>
        <h2 id="what-next-heading" data-testid="what-next-heading" className="mt-4 text-balance text-3xl font-extrabold tracking-tight text-navy-900 sm:text-4xl">
          What happens next?
        </h2>
      </div>
      <div className="mt-10 grid gap-6 md:grid-cols-3">
        {WHAT_HAPPENS_NEXT.map((s, i) => (
          <Reveal key={s.step} delay={i * 0.08} className="h-full">
            <div className="flex h-full flex-col rounded-xl border border-slate-200 bg-white p-7">
              <span className="font-mono text-2xl font-medium text-gold-700" aria-hidden="true">
                {s.step}
              </span>
              <h3 className="mt-4 text-lg font-extrabold tracking-tight text-navy-900">{s.title}</h3>
              <p className="mt-2.5 text-sm leading-relaxed text-slate-600">{s.copy}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
